export default {
    namespaced: true,
    state: {
        activeId: null,
    },
    getters: {
        ['getActiveId'](state) {
            return state.activeId;
        }
    },
    mutations: {
        setActiveId(state, activeId) {
            state.activeId = activeId;
        }
    }
}
